import React from 'react';
import MedicationItem from './AdditionalItem';
import type { DataAnnotationAdditionalContent } from '../../../../lib';
import { useDataAnnotation } from '../context/DataAnnotationProvider';

export type CaseAdditionalSection = Record<
  string,
  DataAnnotationAdditionalContent
>[];

const AnnotationCaseAddictionalSection = () => {
  const { currentCase } = useDataAnnotation();
  const additionalSectionData =
    Object.keys(currentCase?.additionalSection || {}) || [];

  return (
    <div className="d-flex flex-column gap-4 p-3">
      {currentCase &&
        additionalSectionData.length > 0 &&
        additionalSectionData.map((item, index) => (
          <MedicationItem
            key={`additional-${index}`}
            title={item}
            item={currentCase.additionalSection[item]}
          />
        ))}
    </div>
  );
};

export default AnnotationCaseAddictionalSection;
